import * as React from 'react';
import './css/font.css';
import './css/App.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import {blue, orange, red} from '@mui/material/colors';
import Navigation from "./Navigation";
import Listings from "./Listings";
import TestApiCall from "./TestApiCall";


const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            light: blue[300],
            main: blue[500],
            dark: blue[700],
            darker: blue[900]
        },
        secondary: {
            light: orange[300],
            main: orange[500],
            dark: orange[700],
            darker: orange[900]
        },
    },
});

function App() {
  return (
      <ThemeProvider theme={theme}>
          <Navigation/>
      </ThemeProvider>
  );
}
export default App;
